<script>
  export let imageUrl;
  export let musicUrl;
  let audioRef;
  let isPlaying = false;

  function toggleMusic() {
    const audio = audioRef; //get the audio element
    if (!isPlaying) {
      audio.play();
      isPlaying = true;
    } else {
      audio.pause();
      isPlaying = false;
    }
  }
</script>

<div class="outer" on:click={toggleMusic}>
  <img class="thumbnail" src={imageUrl} alt="Click to play" />
  {#if isPlaying}
    <img class="icon" src="/icons/pause.svg" alt="pause Icon" />
  {:else}
    <img class="icon" src="/icons/play.svg" alt="play Icon" />
  {/if}
  <audio src={musicUrl} bind:this={audioRef} />
</div>

<style>
  .outer {
    position: relative;
  }
  .thumbnail {
    width: 200px;
    height: 200px;
  }

  .icon {
    position: absolute;
    top: 75px;
    left: 75px;
    width: 50px;
    height: 50px;
  }
</style>
